<template>
	<div style="margin-top: 50px;margin-left: 50px;">
		
		<el-form :rules="rules" :inline="true" :model="dataForm" class="demo-form-inline">
			
			<el-form-item label="手机号：" prop="mobile">
				<el-input v-model="dataForm.mobile" placeholder="请输入手机号" clearable />
			</el-form-item>

			<el-form-item>
				<el-popconfirm title="确定提交吗？" @confirm="confirmPost(dataForm)">
				    <template #reference>
				        <el-button type="danger" size="small">提交</el-button>
				    </template>
				</el-popconfirm>
			</el-form-item>
		</el-form>
		
	</div>
</template>
<script setup>
	import {
		ref,
		reactive
	} from 'vue'
	import {
		formPost
	} from "@/api/agent";
	import {
		ElMessage
	} from 'element-plus'

	// 表单
	const dataForm = reactive({
		mobile: '',
	})
	
	// const rules = reactive({
	//     mobile: [{ required: true, message: '手机号不能为空', trigger: 'blur' }],
	// })
	
	
	
	// 提交
	const confirmPost = async (dataForm) => {
	    const { code, message } = await formPost({
	        mobile: dataForm.mobile
	    })
		
		console.log(dataForm.mobile)
	    if (code === 200) {
			ElMessage.success(message);
			dataForm.mobile = ''
	    }
	}
	
	
	
</script>
<style lang="less" scoped>
	.main {
		padding-top: 10px;
		padding-left: 10px;
	}

	.pagination {
		padding-left: 300px;
		margin-top: 10px;
	}
</style>